import { vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../../../public/icons/reportbook/promote_green.svg'
import _imports_1 from '../../../../public/icons/reportbook/parameter.svg'
import _imports_2 from '../../../../public/icons/models/search-10.svg'
import _imports_3 from '../../../../public/icons/models/close.svg'
import _imports_4 from '../../../../public/icons/explorer/expander.svg'


const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "editorContent" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled", "value"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 5,
  class: "wbtn-array"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "member-wrapper-inner"
}
const _hoisted_14 = { class: "memberSelectorToolbar" }
const _hoisted_15 = { class: "toolbarItem" }
const _hoisted_16 = { style: {"grid-row":"1/1","display":"grid","grid-template-columns":"25px auto 45px 35px 1px 50px","height":"30px","border":"1px solid var(--thin-border)","border-radius":"2px"} }
const _hoisted_17 = ["title"]
const _hoisted_18 = ["placeholder", "disabled"]
const _hoisted_19 = { style: {"height":"28px"} }
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 1,
  class: "loading"
}
const _hoisted_22 = { style: {"position":"relative","top":"-5px"} }
const _hoisted_23 = ["title"]
const _hoisted_24 = { style: {"text-align":"center","line-height":"25px"} }
const _hoisted_25 = ["title"]
const _hoisted_26 = ["title"]
const _hoisted_27 = { class: "toolbarItem" }
const _hoisted_28 = { class: "showSelection" }
const _hoisted_29 = { style: {"padding-right":"10px","height":"30px","position":"relative","top":"-3px"} }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { value: "nameAndCaption" }
const _hoisted_32 = { value: "name" }
const _hoisted_33 = { value: "caption" }
const _hoisted_34 = { class: "showOnlyMatches" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = ["placeholder", "disabled"]
const _hoisted_37 = {
  key: 0,
  class: "modalContent"
}
const _hoisted_38 = {
  key: 1,
  class: "modalContent"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "modalItem" }
const _hoisted_41 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Empty = _resolveComponent("Empty")!
  const _component_TreeParameterNode = _resolveComponent("TreeParameterNode")!
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.param.style == 'Input')
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            disabled: _ctx.ReadOnlyMode,
            type: "text",
            class: _normalizeClass({interpolation: true}),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.CurrentValue.name) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ParameterText_Change($event)))
          }, null, 40, _hoisted_3)), [
            [_vModelText, _ctx.CurrentValue.name]
          ])
        : (_ctx.param.style == 'Date' && (_ctx.FormatDate(_ctx.CurrentValue.key)==null || !_ctx.FormatDate(_ctx.CurrentValue.key).startsWith('{')))
          ? (_openBlock(), _createElementBlock("input", {
              key: 1,
              disabled: _ctx.ReadOnlyMode,
              type: "date",
              class: _normalizeClass({interpolation: false}),
              value: _ctx.FormatDate(_ctx.CurrentValue.key),
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ParameterDate_Change($event)))
            }, null, 40, _hoisted_4))
          : (_ctx.param.style == 'Date')
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 2,
                disabled: _ctx.ReadOnlyMode,
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.CurrentValue.name) = $event)),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ParameterText_Change($event)))
              }, null, 40, _hoisted_5)), [
                [_vModelText, _ctx.CurrentValue.name]
              ])
            : (_ctx.captionSearchResolved && (_ctx.param.style == 'Tree' || _ctx.useCaptionSearchPicker))
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 3,
                  disabled: _ctx.ReadOnlyMode,
                  type: "text",
                  style: {"cursor":"pointer"},
                  onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openMemberModal && _ctx.openMemberModal(...args)), ["stop"])),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.CurrentValueLabel) = $event)),
                  readonly: ""
                }, null, 8, _hoisted_6)), [
                  [_vModelText, _ctx.CurrentValueLabel]
                ])
              : (_ctx.captionSearchResolved && _ctx.param.style == 'List')
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 4,
                    disabled: _ctx.ReadOnlyMode,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.CurrentValue) = $event))
                  }, [
                    (_ctx.IsUsingAReportBookParameter)
                      ? (_openBlock(), _createElementBlock("option", {
                          key: 0,
                          value: _ctx.CurrentValue
                        }, _toDisplayString(_ctx.CurrentValueLabel), 9, _hoisted_8))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.param.values, (choice, k) => {
                      return (_openBlock(), _createElementBlock("option", { value: choice }, _toDisplayString(_ctx.ValueLabel(choice)), 9, _hoisted_9))
                    }), 256))
                  ], 8, _hoisted_7)), [
                    [_vModelSelect, _ctx.CurrentValue]
                  ])
                : _createCommentVNode("", true),
      (_ctx.ShowButtonArray && !_ctx.ReadOnlyMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "wbtn",
              style: {"padding":"5px"},
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.PromoteParameter())),
              disabled: _ctx.IsReportBookParameter || _ctx.ReadOnlyMode
            }, [...(_cache[20] || (_cache[20] = [
              _createElementVNode("img", { src: _imports_0 }, null, -1)
            ]))], 8, _hoisted_11),
            _createElementVNode("div", {
              class: "wbtn",
              style: {"padding":"5px"},
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.ReportBookParameterModal = true)),
              disabled: _ctx.IsReportBookParameter || _ctx.ReadOnlyMode
            }, [...(_cache[21] || (_cache[21] = [
              _createElementVNode("img", {
                class: "accent-svg",
                src: _imports_1
              }, null, -1)
            ]))], 8, _hoisted_12)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.TreeParameterModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.TreeParameterModal = false)),
          size: _ctx.useCaptionSearchPicker ? 'lg' : undefined
        }, {
          header: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(["modalTitle", {memberPickerTitle: _ctx.useCaptionSearchPicker}])
            }, _toDisplayString(_ctx.param.label), 3)
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass({memberWrapper: _ctx.useCaptionSearchPicker})
            }, [
              (_ctx.useCaptionSearchPicker)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", {
                            title: _ctx.Localizer.Localize('Search_PascalCase'),
                            style: {"position":"relative","top":"-5px"}
                          }, [...(_cache[22] || (_cache[22] = [
                            _createElementVNode("img", { src: _imports_2 }, null, -1)
                          ]))], 8, _hoisted_17),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.TreeSearchText) = $event)),
                            placeholder: _ctx.Localizer.Localize('DimensionMemberSelector_Member_Name'),
                            disabled: _ctx.ReadOnlyMode,
                            style: {"height":"30px","border":"none","background":"none","outline":"none"}
                          }, null, 8, _hoisted_18), [
                            [_vModelText, _ctx.TreeSearchText]
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            (_ctx.HasTreeSearch && !_ctx.CurrentlySearching)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: "text",
                                  disabled: true,
                                  style: {"max-width":"fit-content","border-style":"none","height":"28px","display":"block"},
                                  value: _ctx.MatchCountText
                                }, null, 8, _hoisted_20))
                              : (_ctx.CurrentlySearching)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                                : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            (_ctx.TreeSearchText)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "clearSearch theme-svg",
                                  src: _imports_3,
                                  title: _ctx.Localizer.Localize('Controls_Clear'),
                                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.clearMemberSearch && _ctx.clearMemberSearch(...args)))
                                }, null, 8, _hoisted_23))
                              : _createCommentVNode("", true)
                          ]),
                          _cache[25] || (_cache[25] = _createElementVNode("div", { style: {"border-right":"1px solid var(--thin-border)","height":"24px","margin-top":"2px"} }, null, -1)),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", {
                              title: _ctx.Localizer.Localize('DimensionMemberSelector_Move_To_Previous'),
                              style: {"display":"inline"},
                              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.moveToPreviousMatch && _ctx.moveToPreviousMatch(...args)))
                            }, [...(_cache[23] || (_cache[23] = [
                              _createElementVNode("img", {
                                class: "upArrow",
                                src: _imports_4,
                                style: {"cursor":"pointer"}
                              }, null, -1)
                            ]))], 8, _hoisted_25),
                            _createElementVNode("div", {
                              title: _ctx.Localizer.Localize('DimensionMemberSelector_Move_To_Next'),
                              style: {"display":"inline"},
                              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.moveToNextMatch && _ctx.moveToNextMatch(...args)))
                            }, [...(_cache[24] || (_cache[24] = [
                              _createElementVNode("img", {
                                class: "downArrow",
                                src: _imports_4,
                                style: {"cursor":"pointer"}
                              }, null, -1)
                            ]))], 8, _hoisted_26)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.Localizer.Localize('Show')), 1),
                          _withDirectives(_createElementVNode("select", {
                            class: "memberDisplaySelect",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.displayMode) = $event)),
                            disabled: _ctx.ReadOnlyMode,
                            style: {"height":"30px","position":"relative","border-radius":"2px","top":"-1px"}
                          }, [
                            _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.Localizer.Localize('DimensionMemberSelector_Member_Name_And_Caption')), 1),
                            _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.Localizer.Localize('DimensionMemberSelector_Member_Name_Only')), 1),
                            _createElementVNode("option", _hoisted_33, _toDisplayString(_ctx.Localizer.Localize('DimensionMemberSelector_Member_Caption_Only')), 1)
                          ], 8, _hoisted_30), [
                            [_vModelSelect, _ctx.displayMode]
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_34, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.ShowOnlyMatches) = $event)),
                            disabled: _ctx.ReadOnlyMode
                          }, null, 8, _hoisted_35), [
                            [_vModelCheckbox, _ctx.ShowOnlyMatches]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.Localizer.Localize('FormParameterEditor_ShowOnlyMatches')), 1)
                        ])
                      ])
                    ])
                  ]))
                : (_ctx.SearchWFParametersFeatureFlagValue)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      class: "treeSearchInput",
                      type: "text",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.TreeSearchText) = $event)),
                      placeholder: _ctx.Localizer.Localize('Search_PascalCase'),
                      disabled: _ctx.ReadOnlyMode
                    }, null, 8, _hoisted_36)), [
                      [_vModelText, _ctx.TreeSearchText]
                    ])
                  : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.useCaptionSearchPicker ? ['showStriped', {noMatches: _ctx.ShowNoMatchEmpty}] : 'modalContent')
              }, [
                (_ctx.ShowNoMatchEmpty)
                  ? (_openBlock(), _createBlock(_component_Empty, { key: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Localizer.Localize('FormParameterEditor_NoMatchingMembers')), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_TransitionGroup, {
                      key: 1,
                      name: "fso",
                      tag: "span"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.RootNodes, (node, i) => {
                          return (_openBlock(), _createBlock(_component_TreeParameterNode, {
                            key: _ctx.key(i),
                            Definition: node,
                            SearchText: _ctx.TreeSearchTextForCurrentMode,
                            AutoExpand: _ctx.AutoExpandMatches,
                            ShowOnlyMatches: _ctx.ShowOnlyMatchesForNode,
                            MatchNameAndCaption: _ctx.useCaptionSearchPicker,
                            DisplayMode: _ctx.useCaptionSearchPicker ? _ctx.displayMode : '',
                            HighlightedKey: _ctx.useCaptionSearchPicker ? _ctx.HighlightedMemberKey : '',
                            GridRows: _ctx.useCaptionSearchPicker
                          }, null, 8, ["Definition", "SearchText", "AutoExpand", "ShowOnlyMatches", "MatchNameAndCaption", "DisplayMode", "HighlightedKey", "GridRows"]))
                        }), 128))
                      ]),
                      _: 1
                    }))
              ], 2)
            ], 2)
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_CommonButton, {
              type: _ctx.ButtonType.Default,
              text: _ctx.Localizer.Localize('Cancel_PascalCase'),
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.TreeParameterModal = false))
            }, null, 8, ["type", "text"]),
            _createVNode(_component_CommonButton, {
              type: _ctx.ButtonType.Primary,
              disabled: !_ctx.CanChooseTreeParameterValue || _ctx.ReadOnlyMode,
              text: _ctx.Localizer.Localize('Ok_PascalCase'),
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.ChooseTreeParameterValue()))
            }, null, 8, ["type", "disabled", "text"])
          ]),
          _: 1
        }, 8, ["size"]))
      : _createCommentVNode("", true),
    (_ctx.ReportBookParameterModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onClose: _ctx.CancelPickReportBookParameter
        }, {
          header: _withCtx(() => [...(_cache[26] || (_cache[26] = [
            _createElementVNode("span", { class: "modalTitle" }, "Pick a report book parameter", -1)
          ]))]),
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              (_ctx.ReportBookParameters === null || _ctx.ReportBookParameters.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createVNode(_component_Empty, null, {
                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                        _createTextVNode("No report book parameters", -1)
                      ]))]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createVNode(_TransitionGroup, {
                      name: "fso",
                      tag: "span"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ReportBookParameters, (param, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["modalItemWrapper", {even: i%2==0}]),
                            key: _ctx.key(i),
                            onClick: ($event: any) => (_ctx.SelectReportBookParameter(param)),
                            style: _normalizeStyle({'--i':i/_ctx.ReportBookParameters.length})
                          }, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("span", _hoisted_41, _toDisplayString(param.bookParameter.label), 1)
                            ])
                          ], 14, _hoisted_39))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
            ])
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_CommonButton, {
              type: _ctx.ButtonType.Default,
              text: _ctx.Localizer.Localize('Cancel_PascalCase'),
              onClick: _ctx.CancelPickReportBookParameter
            }, null, 8, ["type", "text", "onClick"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
}